export const profileValidations = {
	name: {
		required: {
			value: true,
			message: "Заполните поле",
		},
		minLength: {
			value: 2,
			message: "Минимум 2 символов",
		},
		maxLength: {
			value: 255,
			message: "Максимум 255 символов",
		},
		validate: {
			matchPattern: (v) =>
				/^[А-ЯЁ][а-яё]*(?:-[А-ЯЁ][а-яё]*)*$/.test(v) || "Имя указано неверно",
		},
	},
	fname: {
		required: {
			value: false,
		},
		validate: {
			matchPattern: (v) => {
				if (v?.trim() !== "") {
					return (
						/^[А-ЯЁ][а-яё]*(?:-[А-ЯЁ][а-яё]*)*$/.test(v) || "Фамилия указана неверно"
					);
				}
			},
		},
	},
	lname: {
		required: {
			value: false,
		},
		validate: {
			matchPattern: (v) => {
				if (v?.trim() !== "") {
					return (
						/^[А-ЯЁ][а-яё]*(?:-[А-ЯЁ][а-яё]*)*$/.test(v) ||
						"Отчество указано неверно"
					);
				}
			},
		},
	},
	email: {
		required: {
			value: false,
		},
		maxLength: {
			value: 50,
			message: "Максимум 50 символов",
		},
		validate: {
			matchPattern: (v) => {
				if (v?.length) {
					return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
																		"Адрес электронной почты недействителен.";
				}
			},
		},
	}
}